import { useDispatch } from "react-redux";
import { DispatchType } from "../actions/types";

export const useThunkDispatch = () => useDispatch<DispatchType>();
